import { QRCodeCanvas } from "qrcode.react";
import styled from "styled-components";
import { Colors } from "../Styles/Colors";

const Styles = {
    Frame: styled.div`
        min-height: 100%;
        padding: 48px 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${Colors.schemas.text};
        box-sizing: border-box;
    `,
    Card: styled.div`
        width: min(360px, 100%);
        padding: 28px 24px;
        border: 1px solid ${Colors.schemas.border};
        border-radius: 18px;
        background:
            linear-gradient(180deg, ${ Colors.raw.neon_orange }, ${ Colors.raw.accent_strong });
        box-shadow:
            inset 0 1px 0 rgba(255, 255, 255, 0.05),
            0 18px 42px rgba(0, 0, 0, 0.42);
        text-align: center;
        backdrop-filter: blur(10px);
    `,
    Label: styled.div`
        margin-bottom: 8px;
        color: ${Colors.raw.black};
        font-size: 0.72rem;
        letter-spacing: 0.22em;
        text-transform: uppercase;
    `,
    Title: styled.h2`
        margin: 0;
        color: ${Colors.schemas.text};
        font-size: 1.35rem;
        font-weight: 800;
        letter-spacing: 0.04em;
    `,
    Description: styled.p`
        margin: 12px 0 24px;
        color: ${Colors.schemas.textSecondary};
        font-size: 0.92rem;
        line-height: 1.5;
    `,
    QRFrame: styled.div`
        width: fit-content;
        margin: 0 auto;
        padding: 14px;
        border-radius: 16px;
        background: ${Colors.schemas.primary};
        box-shadow:
            0 0 0 1px rgba(255, 255, 255, 0.18),
            0 18px 36px rgba(0, 0, 0, 0.38);
    `,
    Url: styled.div`
        margin-top: 22px;
        padding: 10px 12px;
        border: 1px solid ${Colors.schemas.border};
        border-radius: 12px;
        background: rgba(255, 255, 255, 0.035);
        color: ${Colors.schemas.textSecondary};
        font-size: 0.78rem;
        word-break: break-all;
    `,
}

export const QRCode = () => {
    const url = window.location.origin;

    return <Styles.Frame>
        <Styles.Card>
            <Styles.Label>Secure Link</Styles.Label>
            <Styles.Title>DataPad verbinden</Styles.Title>
            <Styles.Description>
                Scanne diesen Code mit einem zweiten Gerät, um dieses DataPad zu öffnen.
            </Styles.Description>

            <Styles.QRFrame>
                <QRCodeCanvas
                    value={url}
                    size={210}
                    bgColor={ Colors.schemas.primary }
                    fgColor={ Colors.raw.blue_orange }
                    level="H"
                    includeMargin={true}
                />
            </Styles.QRFrame>

            <Styles.Url>{url}</Styles.Url>
        </Styles.Card>
    </Styles.Frame>
}